import styled from 'styled-components'

const StyledContainer = styled.div`
  .description {
    color: var(--color-gray-105);
  }
`

const TextDescription = ({
  label,
  description
}: {
  label?: string
  description?: string
}) => {
  return (
    <StyledContainer>
      <div className="label">{label}</div>
      <div className="description">{description}</div>
    </StyledContainer>
  )
}

export default TextDescription
